import { useEffect } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { useSubscription } from '@/hooks/useSubscription'
import { analytics } from '@/lib/analytics'

export function PostHogIdentify() {
  const { user } = useAuth()
  const { plan } = useSubscription()

  useEffect(() => {
    if (!user) {
      analytics.reset()
      return
    }

    const authMethod = user.isAnonymous
      ? 'guest'
      : user.providerData[0]?.providerId === 'google.com'
        ? 'google'
        : 'email_link'

    analytics.identify(user.uid, {
      email: user.email,
      plan,
      authMethod,
      isAnonymous: user.isAnonymous,
    })
  }, [user?.uid, plan])

  return null
}
